import React from 'react';
import { FormattedMessage } from 'react-intl';

import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import Body from '@bitcoin-portal/verse-web-components/dist/Body';
import Link from '@bitcoin-portal/verse-web-components/dist/Link';

import H3 from '@components/atoms/H3';

import { useTrackEvent } from '@hooks/useTrackEvent';

import { ContentWrapper, TitleWrapper, Wrapper } from './styled';

const Community = () => {
  const trackEvent = useTrackEvent();
  const query = useStaticQuery(graphql`
    query TelegramImage {
      telegram: file(relativePath: { eq: "lounge-community.png" }) {
        childImageSharp {
          gatsbyImageData(
            width: 320
            placeholder: DOMINANT_COLOR
            formats: [AUTO, WEBP, AVIF]
            transformOptions: { cropFocus: CENTER }
            breakpoints: [375, 600, 900]
          )
        }
      }
    }
  `);
  return (
    <Wrapper>
      <TitleWrapper>
        <H3>
          <FormattedMessage id="lounge.community.title" />
        </H3>
        <Body>
          <FormattedMessage id="lounge.community.subtitle" />
        </Body>
      </TitleWrapper>
      <ContentWrapper>
        <Link
          href="https://guild.xyz/verse"
          newTab
          onClick={() => {
            trackEvent('tap', {
              to: 'https://guild.xyz/verse',
            });
          }}
        >
          <GatsbyImage
            image={query.telegram.childImageSharp.gatsbyImageData}
            alt="Ticket to VIP Telegram Channel"
            style={{
              width: '100%',
              aspectRatio: '320/81',
            }}
          />
        </Link>
      </ContentWrapper>
    </Wrapper>
  );
};

export default Community;
